module.exports = __webpack_public_path__ + "img/5.b829f0fa.png";